<div class="white-border">
    <div class="flex items-center cursor-pointer literots-bar relative pl-10 pr-2" (click)="openDetailsLiterots()">
        <img src="/assets/img/new-hud/star.png" class="absolute z-10 -left-4 star" alt="Literots">
        
        <span class="text mr-2">Literots</span>
        <!-- <span class="text level absolute right-2 top-0 transform -translate-y-full">LV<span class="larger">{{ avatarLevel ? avatarLevel : 1 }}</span></span> -->
        <mat-progress-bar mode="determinate" value="{{levelProgress}}" class="mr-2"></mat-progress-bar>
        <span class="level-progress">{{ levelProgress ? levelProgress : 0 }}%</span>
    </div>
</div>